module.exports = __webpack_public_path__ + "static/media/logo_80_lg.e1537a5d.png";